module.exports = __webpack_public_path__ + "img/Taucherin.07dd535d.svg";